module.exports = __webpack_public_path__ + "img/icon_ht_location.e34da518.svg";